var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTableIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 2,
  y: 3,
  rx: 1.25
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 2,
  y: 10,
  rx: 1.25
}), /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 4,
  x: 9,
  y: 10,
  rx: 1.25
}), /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 4,
  x: 9,
  y: 3,
  rx: 1.25
}), /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 4,
  x: 9,
  y: 17,
  rx: 1.25
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 2,
  y: 17,
  rx: 1.25
}))));
export default SvgTableIcon;